import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // debug: true,
        fallbackLng: 'en',
        supportedLngs: ['en', 'sk', 'cz'],
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: {
                    landing: {
                        threed: "🦊CGI and 3D Artist",
                        programming: "💻Programming Tutor",
                        bioviz: "🧬Sciviz Researcher"
                    },
                    side: {
                        threed: "🦊 CGI and 3D Artist",
                        programming: "💻 Programming Tutor",
                        bioviz: "🧬 Sciviz Researcher"
                    }
                }
            },
            sk: {
                translation: {
                    threeD: {
                        software: "Programy",
                        hardware: "Nástroje",
                        year: "Rok",
                        cesfur: `Ilustrácia pre conbook Česfur 2022. Viac <1>tu</1>.`,
                        hand: `Model pre HCI výskumný projekt simulátoru rogala (v príprave).`,
                        minsk: `3D modely, animácie a fyzikálne simulácie pre exhibíciu s názvom 'Brno→Minsk 1941'. Boli použité umelkyňou Janou Francovou pre videomapping naživo, na budovu okresného súdu v Brne. Viac <1>tu</1>.`,
                        soncup: `Soncup. Osobný projekt.`,
                        brani: `Brani - Tuleň obecný. Osobný projekt.`,
                        gerontosaurus: `Gerontosaurus. Zabudol si zubnú náhradu. Osobný projekt.`,
                        bulb: "Model vytvorený pre výuku kriviek a modifikátorov v programe Blender.",
                        bulbus: `Canis bulbus. Keď sa dotknete jeho chvosta, rozžhaví sa. Prodáno na charitativnej aukcií Česfuru 2022.`,
                        nanachi: "Avatar pre VRChat. Charakter je Nanachi z Made in Abyss.",
                        lamp: "Pixelartový shader pre lávovú lampu založený na SDF. Vytvorené pre hru (v príprave).",
                        drapi: "Digitalizácia a digitálne reštaurovanie hlavy zvieracieho kostýmu, príprava na 3D tlač. Forma získaná pomocou fotogrametrie, ďalej čistená a retopologizovaná v programoch ZBrush a Blender.",
                        musicalVRchat: "Systém pre VRChat, ktorý umožňuje používateľom ovládať animácie pomocou MIDI nástroja. Vo vývoji v spolupráci s mojím študentom.",
                        brain: "V spolupráci s laboratóriom Visitlab sme použili fotogrametriu pre digitalizáciu inventára Anatomického ústavu Masarykovej univerzity. Tento render zobrazuje pravú hemisféru ľudského mozgu.",
                        isostack: "IsoStack. Doplnok pre Blender využívajúci riešenie izomorfizmu grafov na stackovanie UV ostrovov, ktoré majú spoločnú topológiu, ale nie nevyhnutne tvar. Vo vývoji."

                    },
                    side: {
                        language: "Jazyk",
                        im: "Ahoj! Som KiraaCorsac, tiež známy ako Filip Opálený.",
                        looking: "Hľadáte niečo z nasledovného?",

                        threed: "🦊 3D modelovanie, CGI",
                        programming: "💻 Výuka programovania",
                        bioviz: "🧬 Výskum vizualizácií"


                    },
                    landing: {
                        language: "Jazyk",
                        im: "Venujem sa",
                        other: "a veľa iným veciam.",
                        welcome: "Ahoj! Som KiraaCorsac, tiež známy ako Filip Opálený.",
                        click: "Kliknite sem pre viac informácií",

                        threed: "🦊3D modelovaniu a CGI",
                        programming: "💻učeniu programovania",
                        bioviz: "🧬výskumu vizualizácií"
                    },

                    bioviz: {
                        intro: "Som výskumník so <1>vzdelaním z oblasti informatiky</1>. Špecializujem sa na tvorbu <3>využiteľných biochemických vizualizácií</3>. V súčasnosti pracujem na svojom PhD vo ",
                        introcont: "(Masarykova univerzita, Brno, Česká republika) pod vedením doc. Barbory Kozlíkovej PhD."
                    },
                    programming: {
                        hi: "Ahoj,",
                        teaching: "<0>učím informatiku a programovanie</0> v rôznych jazykoch. Venujem sa tomu už asi 4 roky a za tú dobu som pomohol množtvu <2>študentom vysokých škôl zvládnuť skúšky</2>, pomôcť <4>juniorským programátorom s prípravou na ich pohovor</4>, či odovzdať znalosti o programovaní tým, ktorý si hľadali nový koníček.",
                        details: "S výukou mám skúsenosti aj z <1>vedenia seminárnych skupín na Masarykovej univerzite</1> v Brne, kde som učil predmety zaoberajúce sa jazykom C#, základmi algoritmizácie a 3D modelovaním. V minulosti som pracoval ako programátor, dnes pracujem na doktoráte v obore počítačových vizualizácií, ale učiť ma baví - hlavne tých čo chcú vedomosti získavať dobrovoľne. Výuka prebieha <3>cez internet</3> v časoch podľa dohody - preferujem poobedné či večerné časy, som však k dispozícií aj pre nočné sovy :)",
                        price: "Cena",
                        pricevalue: "od 20 Eur/hodina",
                        time: "Preferované časy",
                        timevalue: "poobede, večer, víkendy",
                        langs: "Jazyky",
                        langsvalue: "Python, Java, C, C#, HTML, Javascript, a iné",
                        refs: "Vybrané referencie z doučovateľských webov:"
                    },
                }
            },
            cz: {

                translation: {
                    landing: {
                        language: "Jazyk",
                        im: "Dělám",
                        other: "a mnoho jiných věcí.",
                        welcome: "Ahoj! Jsem KiraaCorsac, též známý jako Filip Opálený.",
                        click: "Klikněte sem pro více informácí",

                        threed: "🦊3D modelování, CGI",
                        programming: "💻výuku programovaní",
                        bioviz: "🧬výzkum vizualizací"

                    },
                    side: {
                        language: "Jazyk",
                        im: "Ahoj! Jsem KiraaCorsac, též známý jako Filip Opálený.",
                        looking: "Hledáte něco z následovného?",

                        threed: "🦊 3D modelování, CGI",
                        programming: "💻 Výuka programovaní",
                        bioviz: "🧬 Výzkum vizualizací"

                    },
                    threeD: {
                        software: "Programy",
                        hardware: "Nástroje",
                        year: "Rok",
                        cesfur: `Ilustrace pro conbook Česfur 2022. Více <1>zde</1>.`,
                        hand: `Model pro HCI výskumný projekt simulátoru rogala (v přípravě).`,
                        minsk: `3D modely, animace a fyzikální simulace pro exhibici s názvem 'Brno→Minsk 1941'. Použito umělkyni Janou Francovou pro živý videomapping na budovu okresního soudu v Brně. Více <1>zde</1>.`,
                        soncup: `Soncup. Osobní projekt.`,
                        brani: `Brani - Tuleň obecný. Osobní projekt.`,
                        gerontosaurus: `Gerontosaurus. Zapomněl si zubní náhradu. Osobní projekt.`,
                        bulb: "Model vytvořený pro výuku křivek a modifikátorů v programu Blender.",
                        bulbus: `Canis bulbus. Když se dotknete jeho ocasu, rozžhaví se. Prodáno v charitativní aukci Česfuru 2022.`,
                        nanachi: "Avatar pro VRChat. Charakter je Nanachi z Made in Abyss.",
                        lamp: "Pixelartový shader pro lávovou lampu založený na SDF. Vytvořeno pro hru (v přípravě).",
                        drapi: "Digitalizace a digitální restaurování hlavy zvířecího kostýmu, příprava pro 3D tisk. Forma získaná fotogrammetrií, dále vyčištěná a retopologizovaná v programech ZBrush a Blender.",
                        musicalVRchat: "Systém pro VRChat, který umožňuje uživatelům ovládat animace pomocí nástroje MIDI. Ve vývoji ve spolupráci s mým studentem.",
                        brain: "Ve spolupráci s laboratoří Visitlab jsme pomocí fotogrammetrie digitalizovali inventář Anatomického ústavu Masarykovy univerzity. Tento render zobrazuje pravou hemisféru lidského mozku.",
                        isostack: "IsoStack. Doplněk pro Blender využívající řešení izomorfismu grafů ke stackování UV ostrovů, které mají společnou topologii, ale ne nutně tvar. Ve vývoji."
                    },

                    programming: {
                        hi: "Ahoj,",
                        teaching: "<2>učím informatiku a programování</2> v různých jazycích. Dělám to už asi 4 roky a za tu dobu jsem pomohl mnoha <4>vysokoškolským studentům složit zkoušky</4>, <6>juniorským programátorům připravit se na pohovor</6> a předal jsem své znalosti programování těm, kteří hledali nového koníčka.",
                        details: "Zkušenosti s výukou mám také z <1>vedení seminárních skupin na Masarykově univerzitě v Brně</1>, kde jsem vedl kurzy jazyka C#, základů algoritmizace, a 3D modelování. V minulosti jsem pracoval jako programátor, dnes pracuji na doktorátu z oblasti počítačových vizualizací, ale učit mě baví - zejména ty, kteří chtějí získat znalosti dobrovolně. Výuka probíhá <3>online</3> v časech podle domluvy - preferuji odpolední nebo večerní časy, ale jsem k dispozici i pro noční sovy :)",
                        price: "Cena",
                        pricevalue: "od 500 Kč/hodina",
                        time: "Preferované časy",
                        timevalue: "odpoledne, večer, víkendy",
                        langs: "Jazyky",
                        langsvalue: "Python, Java, C, C#, HTML, Javascript, a jiné",
                        refs: "Vybrané reference z webů věnovaných doučování (ve slovenštině):"
                    },

                    bioviz: {
                        intro: "Jsem výzkumník s <1>vzděláním v oblasti informatiky</1>. Specializuji se na vytváření <3>použitelných biochemických vizualizací</3>. V současné době pracuji na doktorátu ve",
                        introcont: "(Masarykova univerzita, Brno, Česká republika) pod vedením doc. Barbory Kozlíkové PhD."
                    }
                }
            }
        }
    });

export default i18n;

export const languages = {
    en: { nativeName: 'English' },
    sk: { nativeName: 'Slovensky' },
    cz: { nativeName: "Česky" }
};